import { render, staticRenderFns } from "./InTrend.vue?vue&type=template&id=b63e119c&scoped=true&"
import script from "./InTrend.vue?vue&type=script&lang=js&"
export * from "./InTrend.vue?vue&type=script&lang=js&"
import style0 from "./InTrend.vue?vue&type=style&index=0&id=b63e119c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b63e119c",
  null
  
)

export default component.exports